import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-link-component',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent {
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  clicked(): void {
    this.onClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/LinkComponent/link.component.ts